import React, { useEffect, useState, useCallback } from "react";
import styled from "styled-components";
import Listyear from "../Listyear";

import axios from "axios";
import { API_BASE_URL, DEFAULT_YEAR } from "../../config";

import Loader from "../loader/Loader";
import PlayerYoutube from "./PlayerYoutube";
import ListVideo from "./ListVideo";

const Videoclip = () => {
    const handleGetYear = (data) => {
        fetchDataVideoClip(data);
    };

    const [dataVideoClip, setDataVideoClip] = useState();

    const [linkVideo, setLinkVideo] = useState("");

    const fetchDataVideoClip = (selectYear) => {
        const params = { year: selectYear };
        const headers = {
            "Content-Type": "application/x-www-form-urlencoded",
        };
        axios
            .post(`${API_BASE_URL}videoclip`, params, { headers })
            .then((response) => {
                setDataVideoClip(response.data);
                setLinkVideo(response.data.items[0].vc_link);
            })
            .catch((err) => {
                console.log("Err", err);
            });
    };
    useEffect(() => {
        fetchDataVideoClip(DEFAULT_YEAR);
    }, []);

    const handleChangeVideo = useCallback((link) => {
        setLinkVideo(link);
    }, []);

    return (
        <Container>
            <div className="content-header flex">
                <div className="header-title --flex-center">Video Clip</div>
                <Listyear getYearCallback={handleGetYear} />
            </div>
            {!dataVideoClip ? (
                <Loader />
            ) : (
                <div className="videoclip-content">
                    {/* <PlayerYoutube linkPlay={dataVideoClip.items[0].vc_link} /> */}
                    <PlayerYoutube linkPlay={linkVideo} />
                    <ListVideo
                        dataVideoClip={dataVideoClip}
                        onChangeVideo={handleChangeVideo}
                    />
                </div>
            )}
        </Container>
    );
};

const Container = styled.div`
    .content-header {
        background-color: var(--color-white);

        .header-title {
            font-size: 2.7rem;
            color: var(--color-header-title);
            width: 20rem;
        }
    }
    .videoclip-content {
        display: flex;
        margin-top: 1rem;
        .list-video {
            margin-left: 1rem;
            display: flex;
            flex-flow: wrap;
            gap: 1rem;
            overflow-x: auto;
            max-height: 354px;
        }
        .list-video::-webkit-scrollbar-track {
            -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
            border-radius: 10px;
            background-color: #f5f5f5;
        }

        .list-video::-webkit-scrollbar {
            width: 10px;
            background-color: #f5f5f5;
        }

        .list-video::-webkit-scrollbar-thumb {
            border-radius: 10px;
            -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
            background-color: #555;
        }
    }
    @media only screen and (max-width: 767px) {
        .videoclip-content {
            display: block;
            .list-video {
                margin: 0;
            }
        }
        .content-header {
            .header-title {
                font-size: 2rem;
            }
        }
    }
`;

export default Videoclip;
